/** Normalize order money fields so TVA 20% and shipping 50 DH are always in the displayed total. */

export const ORDER_TAX_RATE = 0.2;
export const ORDER_SHIPPING_FEE = 50;

const toNumber = (value) => {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
};

const round2 = (value) => Math.round(value * 100) / 100;

/** Line total = unit price × quantity (stored item.subtotal can be stale on old rows). */
export const getItemLineTotal = (item = {}) => {
  const price = toNumber(item.price);
  if (price > 0) {
    return round2(price * (toNumber(item.quantity) || 1));
  }
  return toNumber(item.subtotal);
};

export const getOrderTotals = (order = {}) => {
  const hasItems = Array.isArray(order.items) && order.items.length > 0;

  const subtotal = hasItems
    ? round2(order.items.reduce((sum, item) => sum + getItemLineTotal(item), 0))
    : toNumber(order.subtotal);

  const storedShipping = toNumber(order.shipping);
  // Old rows may have shipping=0 (free); apply fixed 50 DH shipping.
  const shipping = storedShipping > 0 ? storedShipping : ORDER_SHIPPING_FEE;

  const tax = round2(subtotal * ORDER_TAX_RATE);

  const grandTotal = round2(subtotal + tax + shipping);

  return {
    subtotal,
    tax,
    shipping,
    grandTotal,
  };
};

export const formatOrderPrice = (value) => `${toNumber(value).toFixed(2)} DH`;
